import { useTranslation } from 'react-i18next';
import { BatchForm } from './BatchForm';

export const CreateBatch = () => {
	const { t } = useTranslation();

	return (
		<div className="p-5">
			<h2>{t('createBatch')}</h2>
			<BatchForm />
		</div>
	);
};
